const angular = require('angular');
const ngRoute = require('angular-route');
import routing from './main.routes';

export class MainController {
  $http;


  /*@ngInject*/
  constructor($http) {
    this.$http = $http;

  }

  $onInit() {
  }

}

export default angular.module('nomasvelloDashboardApp.main', [
  ngRoute])
    .config(routing)
    .component('main', {
      template: require('./main.pug'),
      controller: MainController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.ts